import { render, staticRenderFns } from "./Connections.vue?vue&type=template&id=68304297&scoped=true"
import script from "./Connections.vue?vue&type=script&lang=ts"
export * from "./Connections.vue?vue&type=script&lang=ts"
import style0 from "./Connections.vue?vue&type=style&index=0&id=68304297&prod&lang=scss"
import style1 from "./Connections.vue?vue&type=style&index=1&id=68304297&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68304297",
  null
  
)

export default component.exports